import { extendTheme } from '@blockanalitica/ui';
import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { colors } from './colors';
import space from './space';
import sizes from './sizes';
import { card } from './components/card';
import { cardBody } from './components/cardBody';
import { kpiHeader } from './components/kpiHeader';
import { kpiFooter } from './components/kpiFooter';
import { kpiCardFooter } from './components/kpiCardFooter';
import { linkButton } from './components/linkButton';
import { listHeader } from './components/listHeader';
import { listItem } from './components/listItem';
import { cardHeader } from './components/cardHeader';
import { chartKpi } from './components/ChartKpis/chartKpi';
import { chartKpiPoint } from './components/ChartKpis/chartKpiPoint';
import { chartKpiLabel } from './components/ChartKpis/chartKpiLabel';
import { chartKpiValue } from './components/ChartKpis/chartKpiValue';
import { chartKpiSubValue } from './components/ChartKpis/chartKpiSubValue';
import { chart } from './components/chart';
import { select } from './components/select';
import { sidebar } from './components/sidebar';
import { collapsableSidebar } from './components/collapsableSidebar';
import { headerCell } from './components/headerCell';
import { table } from './components/table';
import { tableCell } from './components/tableCell';
import { displaySwitch } from './components/displaySwitch';
import { displaySwitchOption } from './components/displaySwitchOption';
import { currencyValue } from './components/currencyValue';
import { input } from './components/input';
import { walletAddressHeader } from './components/walletAddressHeader';
import { dropdown } from './components/dropdown';
import { dropdownHeader } from './components/dropdownHeader';
import { dropdownList } from './components/dropdownList';
import { dropdownOption } from './components/dropdownOption';

export const theme: Theme = extendTheme({
  rootFontSize: '13px',
  breakpoints: [600, 768, 1024, 1280],
  charts: {
    minFontSize: 9,
    maxFontSize: 12
  },
  colors,
  sizes,
  space,
  components: [
    select,
    card,
    cardBody,
    cardHeader,
    kpiHeader,
    kpiFooter,
    kpiCardFooter,
    linkButton,
    listHeader,
    listItem,
    chartKpi,
    chartKpiPoint,
    chartKpiLabel,
    chartKpiValue,
    chartKpiSubValue,
    chart,
    sidebar,
    collapsableSidebar,
    headerCell,
    table,
    tableCell,
    displaySwitch,
    displaySwitchOption,
    currencyValue,
    input,
    walletAddressHeader,
    dropdown,
    dropdownHeader,
    dropdownList,
    dropdownOption
  ]
});
